<div style="display: flex; align-items: center;">
    <div>
        {{name}}
    </div>
    <img src="assets/img/infoIcon.png" (click)="showInfoPopup()" style="width: 16px; height: 16px; margin-left: 8px; cursor: pointer;">
</div>